import { createFileRoute } from '@tanstack/react-router';
import PaginationHeader from '@/lib/common/components/PaginationHeader';
import usePageLimit from '@/lib/common/hooks/usePageLimit';
import LoadingCard from '@/lib/loading/components/LoadingCard';
import useRounds from '@/lib/rounds/hooks/useRounds';
import { PaginationResponse } from '@/lib/utils/typeUtils';
import { Button } from '@heroui/react';
import { useEffect, useState } from 'react';
import AddNewRoundForm from '@/components/rounds/AddNewRoundForm';
import RoundsList from '@/components/rounds/RoundsList';

export const Route = createFileRoute('/rounds/')({
    component: RouteComponent,
});

function RouteComponent() {
    const pageLimit = usePageLimit();
    const [pageData, setPageData] = useState<PaginationResponse<unknown>>();
    const { rounds, data, isLoading, refetch } = useRounds({ page: pageLimit.page, limit: pageLimit.limit });

    useEffect(() => {
        if (data) {
            setPageData(data);
        }
    }, [data]);

    const [addNewRound, setAddNewRound] = useState(false);
    return (
        <div className=' mx-auto grid px-2 md:max-w-5xl  '>
            <div className='grid grid-cols-2 items-center px-2'>
                <div className='text-lg font-semibold  md:py-2'>My Rounds</div>
                <div className='justify-self-end text-lg font-semibold  '>
                    <Button variant='light' color='primary' onPress={() => setAddNewRound(true)}>
                        Log new round
                    </Button>
                </div>
            </div>
            {addNewRound && <AddNewRoundForm setAddNewRound={setAddNewRound} />}
            {!!pageData && (
                <PaginationHeader pages={pageData} usePageLimit={pageLimit} total={pageData.page_count} />
            )}
            <div className='simple-card mb-24 p-3'>
                <div>
                    {isLoading && <LoadingCard count={5} />}
                    {!isLoading && <RoundsList rounds={rounds} mutateRounds={refetch} />}
                </div>
            </div>
        </div>
    );
}
